goog.provide('el8.appshared.dialog.guarantor');

goog.require('el8.appshared.mindreaderOpts');
goog.require('el8.template.appshared.dialog.guarantor');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.uiwidget.alert');
goog.require('el8.util.validate');

//
// Behind el8Globals.FEATURES.FrontOfficeNewKareo
//
// Requires callbackFn
//
el8.appshared.dialog.guarantor = (function(){
    var callbackFn;
    var that = new el8.uiwidget.FormDialog({
        title: 'Edit Guarantor',
        modal: true,
        autoHeight: true,
        position: 'center',
        width: 500,
        contentFn: el8.template.appshared.dialog.guarantor.content,
        showXButton: el8Globals.READ_ONLY
    });

    var opts = {
        fields: [
            {
                name: 'relationship'
            },
            {
                name: 'firstName',
                infoText: "First name",
                validate: {required: true}
            },
            {
                name: 'lastName',
                infoText: "Last name",
                validate: {required: true}
            },
            {
                name: 'address',
                maxLength: 200,
                infoText: 'Street',
                validate: {required: true}
            },
            {
                name: 'city',
                maxLength: 50,
                infoText: 'City',
                validate: {required: true}
            },
            {
                name: 'state',
                maxLength: 2,
                infoText: 'State',
                validate: {required: true}
            },
            {
                name: 'zip',
                maxLength: 10,
                infoText: 'Zip',
                validate: {required: true}
            },
            {
                name: 'phone',
                maxLength: 20,
                infoText: 'e.g. 555-555-5555'
            }
        ],
        validationOpts: el8.util.validate.highlightInputOpts
    };

    var form = new el8.uiwidget.Form(opts);

    form.addButton('continue', 'Continue', function() {
        if (!form.isValid()) { return; }
        var guarantor = extractGuarantor();
        if (callbackFn) { callbackFn(guarantor); }
        that.hide();
    }, true);
    form.addButton('remove', 'Remove', function (argument) {
        if (callbackFn) { callbackFn(null); }
        that.hide();
    }, false);
    form.addButton('cancel', 'Cancel', function() { that.hide(); }, false);
    that.setForm(form);

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
    };

    var super_show = that.show;
    that.show = function(spec) {
        spec = spec || {};
        super_show.call(that);
        callbackFn = spec.callbackFn;
        var guarantor = spec.formGuarantor;
        if (guarantor && guarantor.getRelationship() !== '') {
            form.populate(guarantor.asSoyMap());
        }
        that.adjustPosition();
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
    };

    function extractGuarantor() {
        var formMap = form.getMapped();
        var newGuarantor = el8.ptdata.model.guarantor(formMap);
        return newGuarantor;
    }

    return that;
})();
